import { Children, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import './InnerPages.css';
import React from 'react';

export function InnerPages(props) {
    const arrayChildren = Children.toArray(props.children);
    const [page, setPage] = useState(1);
    const history = useHistory();
    const queryPage = new URLSearchParams(useLocation().search).get('page');
    const [showDocument, setShowDocument] = useState(false);
    useEffect(() => {
        if (queryPage) {
            setPage(parseInt(queryPage));
        }
    }, []);
    const onClickPrevious = async (e) => {
        e.preventDefault();
        if (props.onChangePage) {
            await props.onChangePage();
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const newPage = page - 1;
        setPage(newPage);
        history.push({
            search: `?page=${newPage}`,
        });
    };
    const onClickNext = async (e) => {
        e.preventDefault();
        if (props.onChangePage) {
            await props.onChangePage();
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const newPage = page + 1;
        setPage(newPage);
        history.push({
            search: `?page=${newPage}`,
        });
    };

    const onClickViewDocument = () => {
        setShowDocument(!showDocument);
    };

    const onClickPrint = () => {
        window.print();
    };

    return (
        <div className={`inner-pages-container ${showDocument ? 'show-document' : ''}`}>
            {Children.map(arrayChildren, (child, index) => {
                return (
                    <div key={index} className={`inner-page ${index + 1 !== page ? 'hide' : ''}`}>
                        {child}
                    </div>
                );
            })}
            <div className="page-buttons">
                <div className="page-buttons-left">
                    <button
                        className={`main-button page-button ${page === arrayChildren.length || showDocument ? 'rev-hide' : ''}`}
                        onClick={onClickNext}
                    >
                        Next
                    </button>
                    <button
                        className={`main-button page-button ${page === 1 || showDocument ? 'rev-hide' : ''}`}
                        onClick={onClickPrevious}
                    >
                        Previous
                    </button>
                    {props.afterLeftButtons}
                </div>
                <div className="page-pagination">{`Page ${page} of ${arrayChildren.length}`}</div>
                <div className="page-buttons-right">
                    <button className={'main-button'} onClick={onClickViewDocument}>
                        {showDocument ? 'Hide Document' : 'Show Entire Document'}
                    </button>
                    {showDocument === true && (
                        <button className={'main-button'} onClick={onClickPrint}>
                            Print
                        </button>
                    )}

                    {props.rightButtons}
                </div>
            </div>
        </div>
    );
}
